import { graphql } from "gatsby";
import * as React from "react";

import { getPostMapped } from "../../contexts/blog/infrastructure/postSanityDataMapper";
import AsidePost from "../../modules/AsidePost/AsidePost";
import ContentList from "../../modules/ContentList/ContentList";
import IndexOfHeadings from "../../modules/IndexOfHeadings/IndexOfHeadings";
import Layout from "../../modules/Layout/Layout";
import { HrefLang } from "../../modules/SEO/iseo";
import PostMarkupSchema from "../../modules/SEO/PostMarkupSchema";
import { SEO } from "../../modules/SEO/SEO";
import { IPageProps } from "../../types/thecookies";
import AuthorResume from "../../views/blog/post/AuthorResume/AuthorResume";
import { Hero } from "../../views/blog/post/Hero";
import PostSources from "../../views/blog/post/PostSources/PostSources";

const PagePost = (props: IPageProps<Queries.PostPageQuery>) => {
  const post = getPostMapped(props.data?.post);

  return (
    <Layout classNames={"l-post"} language={props.pageContext.language}>
      <Hero post={post} />
      <div className="container">
        {/*<PostResume post={post} />*/}
        <div className="o-post grid-70-30">
          <main className="m-post-content">
            <ContentList data={props.data?.post?.contentList} />
            {post.sources.length > 0 && <PostSources urls={post.sources} />}
          </main>
          <AsidePost>
            <IndexOfHeadings
              data={{ indexList: props.data?.post?.contentList }}
              settings={{ withAccordion: true }}
            />
          </AsidePost>
        </div>
        <AuthorResume post={post} />
      </div>
    </Layout>
  );
};
export default PagePost;

export const Head = (props: IPageProps<Queries.PostPageQuery>) => {
  const { post } = props.data;
  return (
    <>
      <SEO
        metas={{
          slug: props.data.post?.slug,
          language: props.pageContext.language,
          seo: {
            ...post?.seo,
            thumbnail: post?.thumbnail?.secure_url,
          },
          hrefLangList: props.data.hrefLangList.nodes.map((item: HrefLang) => {
            return {
              language: item.language,
              slug: item.slug,
            };
          }),
        }}
      />
      {post && <PostMarkupSchema post={post} />}
    </>
  );
};

export const query = graphql`
  query PostPage($id: String!, $reference: String!) {
    post: sanityPost(id: { eq: $id }) {
      ...seo
      id
      _id
      contentList {
        __typename
        ... on SanityMd {
          value
        }
        ... on SanityPhoto {
          alt
          title
          asset {
            gatsbyImageData(layout: CONSTRAINED, placeholder: NONE)
          }
          media {
            public_id
            resource_type
          }
        }
        ... on SanityIframe {
          url
          title
        }
        ... on SanityCaptureEmails {
          text
          cta
          highlight
        }
        ... on SanityScript {
          title
          code
        }
        ... on SanityCode {
          language
          code
          highlightedLines
        }
        ... on SanityTable {
          rows {
            cells
          }
        }
        ... on SanityIndexOfHeadings {
          title
        }
      }
      author {
        biography
        summary {
          title
          text
          photo {
            asset {
              gatsbyImageData(width: 332, placeholder: BLURRED)
              secure_url
            }
          }
        }
        name
        job
        socials {
          instagram
          linkedin
          twitter
        }
        slug
      }
      categories {
        _id
        title
        description
        slug
      }
      _id
      title
      slug
      color
      sources
      thumbnail {
        gatsbyImageData(width: 250, placeholder: BLURRED)
        secure_url
      }
      seo {
        canonical
        desc
        seo_robots
        title
      }
      publishedAt
      _updatedAt
      updatedAt
    }
    hrefLangList: allSanityPost(filter: { ref: { eq: $reference } }) {
      nodes {
        language
        slug
      }
    }
  }
`;
